import { createAction, createSlice } from "@reduxjs/toolkit";
import {
  Colors,
  FontWeight,
  Radius,
  Shadows,
  Spacing,
  ZIndex,
} from "../../constants/theme";
import { THEME_CONFIG } from "../../constants/env";

export const DefaultTheme = {
  colors: Colors,
  radius: Radius,
  shadows: Shadows,
  spacing: Spacing,
  fontWeight: FontWeight,
  zIndex: ZIndex,
};

const initialState = {
  isThemeLoaded: false,
  theme: {
    ...DefaultTheme,
    ...THEME_CONFIG,
    colors: {
    ...DefaultTheme.colors,
    ...THEME_CONFIG.colors
    }
  },
};
export type ITheme = typeof DefaultTheme;
export const resetThemeState = createAction("theme/resetState");

export const themeSlice = createSlice({
  name: "theme",
  initialState: initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload.theme;
      state.isThemeLoaded = true;
    },
  },
});

export const { setTheme } = themeSlice.actions;


export default themeSlice.reducer;
